import React from 'react';
import { I18nextProvider } from '@wix/wix-i18n-config';
import ArenaOnBoardingController from './ArenaOnBoardingController';
import { WixDesignSystemProvider } from '@wix/design-system';

import '@wix/design-system/styles.global.css';

export function createArenaSplitPageApp(props) {
  const { i19n } = props;

  const arenaComponent = () => (
    <ArenaOnBoardingController {...props} />
  );

  const renderingComponent = arenaComponent();
  return (
    <WixDesignSystemProvider features={{ newColorsBranding: true }}>
      <I18nextProvider i18n={i19n}>{renderingComponent}</I18nextProvider>
    </WixDesignSystemProvider>);
}
